__turbopack_context__.v({
  "details": "Details-module__43Vmna__details",
  "summary": "Details-module__43Vmna__summary",
  "summaryIcon": "Details-module__43Vmna__summaryIcon",
});
